const path = 'redux/contact';
export const CONTACTS_LOADED = `${path}/CONTACTS_LOADED`;
export const CONTACT_LOADED = `${path}/CONTACT_LOADED`;

